import { NexoyaProvider } from '../../types/types';

import { useProviders } from '../../context/ProvidersProvider';

import Avatar from '../Avatar/index';

type Props = {
  providerId: number | string;
  className?: string;
  variant?: 'square' | 'circle';
  color?: 'light' | 'dark';
  [x: string]: any;
};
export const classes = {
  root: 'NEXYAvatarProvider',
};

// provider.logo is the '-white' variant, made for dark backgrounds; light backgrounds need the
// suffix stripped or the logo looks bad.
function getLogoUrl(color: string, provider: NexoyaProvider): string {
  if (color === 'dark') return provider.logo || '';
  return provider && provider.logo ? provider.logo.replace('-white', '') : '';
}

const AvatarProvider = ({ providerId, variant = 'square', color = 'light', ...rest }: Props) => {
  const { providerById, activeProviders } = useProviders();
  const provider =
    providerById(Number(providerId)) ?? activeProviders?.find((p) => p.provider_id === Number(providerId));
  const avatarSrc = provider ? getLogoUrl(color, provider) : '';

  return <Avatar src={avatarSrc} alt={provider?.name ?? ''} variant={variant} {...rest} />;
};

export default AvatarProvider;
